module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/object/entries.js
 ** module id = 178
 ** module chunks = 0
 **/